// extracted by mini-css-extract-plugin
export default {"phoneFit":"Posture_phoneFit__htyxp"};